//!function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=48)}({48:function(e,t,r){"use strict"}});

//PAGE


$(document).ready(function(){

    // (function() {
    //   var showChar = 250;
    //   var ellipsestext = "...";
  
    //   $(".truncate").each(function() {
    //     var content = $(this).html();
    //     if (content.length > showChar) {
    //       var c = content.substr(0, showChar);
    //       var h = content;
    //       var html =
    //         '<div class="truncate-text" style="display:block">' +
    //         c +
    //         '<span class="moreellipses">' +
    //         ellipsestext +
    //         '&nbsp;&nbsp;<a href="" class="more-link more">more</a></span></span></div><div class="truncate-text" style="display:none">' +
    //         h +
    //         '<div><a href="" class="more-link less">Less</a></div></span></div>';
  
    //       $(this).html(html);
    //     }
    //   });
  
    //   $(".more-link").click(function() {
    //     var thisEl = $(this);
    //     var cT = thisEl.closest(".truncate-text");
    //     var tX = ".truncate-text";
  
    //     if (thisEl.hasClass("less")) {
    //       cT.prev(tX).toggle();
    //       cT.toggle();//transition to go more > less
    //     } else {
    //       cT.toggle();//transition to go less > more
    //       cT.next(tX).toggle();
    //     }
    //     return false;
    //   });

    // })();

    //social show-hide
    $('.share-trigger').click(function(event) {
        $(this).parents('.share').next('.social_share').toggleClass('hidden show');
    });   
    
});//END READY


$('#product-reviews-summary').click(function() {
    $('html,body').stop().animate( { scrollTop:$('#product-reviews').offset().top - 0 } , 1000);
    $(this).blur();

    var targetPanel = $('#product-reviews').find('.show_more');
    if ($(targetPanel).hasClass('hide')) {
        $(targetPanel).click().blur();
    }
});


// custom bra type options - gifting calendars 
$("#SingleOptionSelector-custom-bra-pref").on("change", function() {
    if ($(this).val() == 'Only specific styles') {
        $('.custom-bra-selections').show();

        $('.custom-bra-selections input').each(function() {
            $(this).prop('name', $(this).data('name'));
        });
    } else {
        // alert("mix");
        $('.custom-bra-selections').hide();

        $('.custom-bra-selections input').each(function() {
            $(this).removeAttr('name');
        });
    }
} );